module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "serahaft"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pii"
    }
  }), _c('i', [_vm._v("A Volume in the Series")])]), _vm._v(" "), _c('p', {
    staticClass: "serahaft"
  }, [_vm._v("Culture and Politics in the Cold War and Beyond")]), _vm._v(" "), _c('p', {
    staticClass: "serbh"
  }, [_vm._v("E"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DITED")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BY")])]), _vm._v(" "), _c('p', {
    staticClass: "sered"
  }, [_c('i', [_vm._v("Edwin A. Martini")])]), _vm._v(" "), _c('p', {
    staticClass: "sered"
  }, [_c('i', [_vm._v("and")])]), _vm._v(" "), _c('p', {
    staticClass: "sered"
  }, [_c('i', [_vm._v("Scott Laderman")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-692ed04f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uma-CAPUTI-0003.vue
// module id = 63
// module chunks = 0